<template>
	<div class="ReSearchFlatBig" v-if="typeof objData !='undefined'">
		<a style="display:none;" :href="`http://test.obzor78.ru/zastrojshchiki/${objData.dev_name_tr.toLowerCase()}/${objData.gk_name_tr.toLowerCase()}/kvartira-${objData.app_id}`" target="_blank">объект на обзор78</a>
		<card>            
			<div class="flatHeader mb-3">
				<div class="flatTitles">
					<div class="row px-3">						
						<h4 class="mr-3">{{objData.app_rooms}}</h4>
						<h4 class="mr-3 gkTaskLink" @click="backToGK()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined'">ЖК &laquo;{{objData.gk_name}}&raquo;</h4>						

						<h4 class="mr-3"  v-if="typeof $GVO.GetAllGet().taskend_id == 'undefined'"><router-link :to="`/data/module/sso/object/complex/${objData.PK}`">ЖК &laquo;{{objData.gk_name}}&raquo;</router-link></h4>
						<h4>Застройщик: {{objData.dev_name}}</h4>
					</div>
					<div class="row px-3">
						<p class="mr-3">Добавлено {{$GVO.convertDateTimeFromMysql(objData.dateadded)}}</p>
						<p>Обновлено {{$GVO.convertDateTimeFromMysql(objData.datemodified)}}</p>                 
					</div>
				</div>
				<div class="row mx-0 align-items-center">
					<div class="bntGroup" >
						<!--
						<base-button type="primary" class="groupfloor" simple @click="toSearchObj()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined' && typeof $GVO.GetAllGet().taskend_id !=0"><i class="tim-icons icon-double-left mr-2"></i>В поиск</base-button>
						<base-button type="primary" class="groupfloor" simple @click="toSearchObjRegular()" v-else><i class="tim-icons icon-double-left mr-2"></i>В поиск</base-button>
						-->
						<base-button type="primary" class="groupfloor" simple @click="backByHistory()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined' && typeof $GVO.GetAllGet().taskend_id !=0"><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
						<base-button type="primary" class="groupfloor" simple @click="backByHistory()" v-else><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					</div>			
					<div class="flatHeader-btn ml-3" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined'">
						<!--base-button type="primary" simple class="mr-3"><i class="tim-icons icon-single-copy-04 mr-2"></i>К сравнению</base-button-->
						<base-button v-if="parseInt(objData.inPresentation)==0" type="primary" simple @click="AddToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>Добавить к презентациям</base-button>
						<base-button v-else type="primary" simple @click="GoToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>В презентации</base-button>
					</div>
				</div>
			</div>

			<div class="flatInfo mb-5">
				<div class="col-sm-12 col-md-6 flatPhotos">
					<div class="flat-carousel">
						<el-carousel :autoplay="false" arrow="always" height="400px" v-if="masFlatImages != ''">
							<el-carousel-item v-for="flat_img in masFlatImages" :key="flat_img.filename">
								<!--<span>{{flat_img.filename}}</span>-->
								<img v-if="flat_img !=''" :src="flat_img.filename" alt="">
							</el-carousel-item>
						</el-carousel>
						<div>
							<img v-if="masFlatImages == ''" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
						</div>
					</div>

					<!--div class="row structure-btns mt-3">
						<base-button type="primary" simple disabled><i class="tim-ic ic-folder mr-2"></i>Регламент застройщика</base-button>
					</div--><!--возможно для релиза попозже-->

				</div>
				<div class="col-sm-12 col-md-5 flatPass px-4">
					<collapse activeIndexType="all" >
						<collapse-item :title="flatPass" >
							<div class="flatPass-container">
								<div class="flatPass-row"><h3 :class="[{'text-success':bLastPrice},{'text-danger':!bLastPrice}]">{{$GVO.formatAmount(parseFloat(objData.app_flatcostwithdiscounts))}}<i class="tim-ic ml-2" :class="[{'ic-arrow-top':bLastPrice},{'ic-arrow-bottom':!bLastPrice},{'text-success':bLastPrice},{'text-danger':!bLastPrice}]"></i></h3></div> 
								<div class="flatPass-row mb-3"><p>Цена при 100% оплате</p></div>
								<div class="flatPass-row objDots"><p>Цена за м² при 100% оплате</p><span></span><p>{{$GVO.formatAmount(parseFloat(objData.app_metrecostwithdiscounts))}}</p></div>
								<div class="flatPass-row objDots"><p>Базовая цена</p><span></span><p>{{$GVO.formatAmount(parseFloat(objData.app_baseflatcost))}}</p></div>
								<div class="flatPass-row objDots"><p>Цена за м² при базовой цене</p><span></span><p class="text-right">{{$GVO.formatAmount(parseFloat(objData.app_metrebase))}}</p></div>
								<div class="flatPass-row objDots"><p>Статус</p><span></span><p class="text-right">{{sold}}</p></div>
								<div class="flatPass-row objDots"><p>S приведенная</p><span></span><p>{{objData.app_stotal}} м²</p></div>
								<div class="flatPass-row objDots"><p>S кухни</p><span></span><p>{{objData.app_skitchen}} м²</p></div>
								<div class="flatPass-row objDots"><p>Санузел</p><span></span><p>{{app_swatercloset}}</p></div>
								<div class="flatPass-row objDots"><p>Высота потолка</p><span></span><p>{{objData.app_height}} м</p></div>
								<div class="flatPass-row objDots"><p>Номер квартиры</p><span></span><p>{{objData.app_number}}</p></div>
								<div class="flatPass-row objDots"><p>Этаж/Этажность</p><span></span><p>{{objData.app_flatfloor}} / {{objData.b_floors}}</p></div>
								<div class="flatPass-row objDots"><p>Отделка</p><span></span><p>{{objData.app_decoration}}</p></div>
							</div>
							<div class="flatPass-btn">
								<!--
								<base-button type="primary" simple  @click="openContacts()" disabled>Контакты</base-button>
								<base-button type="primary" simple disabled>Забронировать</base-button>
								-->
							</div>
							
						</collapse-item>
						<div class="contats-booking" v-if="isOpenContacts == false">
							<ReCuratorContacts/> 
						</div>
						
					</collapse>     
					
				</div>
			</div>

			
			<div class="objectInfo mb-5 pb-4">    
				<div class="col-sm-12 col-md-6 windowMap">
					<div class="row px-3">
						<h4>Жилой комплекс</h4><h4><router-link :to="`/data/module/sso/object/complex/${objData.PK}`" v-if="typeof $GVO.GetAllGet().taskend_id == 'undefined'">&laquo;{{objData.gk_name}}&raquo;</router-link> </h4>
						<h4 class="mr-3 gkTaskLink" @click="backToGK()" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined'">ЖК &laquo;{{objData.gk_name}}&raquo;</h4>

					</div>
					<div class="objectAddress">
						<div class="metro mr-2">
							<div class="row flex-nowrap ml-0 mr-2 align-items-top">
								<i class="tim-ic ic-metro text-primary mr-1"></i>
								<p>{{$GVO.str_replace(',', ', ',objData.metro_name)}}</p>
							</div> 
							<div class="row ml-0 mr-2 align-items-center">
								<i class="metroIc tim-icons icon-user-run text-primary"></i> 
								<p>{{objData.metro_distance}} мин.,</p>									
							</div> 
							<div class="row mx-0 align-items-center">
								<i class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
								<p>{{objData.metro_distance_transport}} мин.</p>									
							</div> 								
						</div>
						<p>{{objData.dis_name}}, {{objData.gk_street}}</p> 
					</div>
					<div class="map mt-2">
						<div class="embed-responsive embed-responsive-16by9" v-if="objData.gid != ''">
							<iframe class="embed-responsive-item" :src="`https://web.3bita.ru/floorplan/widgets/widget.html?gid=${objData.gid}&zoom=17&caption=false`" allowfullscreen allowusermedia></iframe>
						</div>
						<div v-else>
							<yandex-map
								:settings="yamap_settings"
								:coords="yamap_coords"
								:zoom="yamap_zoom"
								:scroll-zoom="false"
								:controls="yamap_controls"
								>
							
								<ymap-marker
										:coords="yamap_markers.coords"
										:marker-id="yamap_markers.id"
										marker-type="placemark"
								/>

							</yandex-map>
						</div>
					</div>
				</div><!--objectMap  заглушка-->

				<div class="col-sm-12 col-md-5 flatPass px-4">
					<collapse activeIndexType="all">
						<collapse-item :title="objectPass" >
							<div class="flatPass-container">
								<div class="flatPass-row objDots"><p>Срок сдачи</p><span></span><p class="text-right">{{$GVO.convertDateFromMysql(objData.b_endingperiod)}}</p></div>
								<div class="flatPass-row objDots"><p>Ключи</p><span></span><p>{{objData.keyperiod}}</p></div>
								<div class="flatPass-row objDots"><p>Корпус</p><span></span><p>{{objData.b_corp}}</p></div>
								<div class="flatPass-row objDots"><p>Секция</p><span></span><p>{{objData.app_section}}</p></div>
								<div class="flatPass-row objDots"><p>Технология строительства</p><span></span><p class="text-right">{{objData.b_buildingtype}}</p></div>
								<div class="flatPass-row objDots"><p>Договор</p><span></span>
									<p class="text-right" v-if="objData.contracttypeid == 1">{{this.$GVO.GetCat('CAT_ContractTypes', 1).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 2">{{this.$GVO.GetCat('CAT_ContractTypes', 2).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 3">{{this.$GVO.GetCat('CAT_ContractTypes', 3).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 4">{{this.$GVO.GetCat('CAT_ContractTypes', 4).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 5">{{this.$GVO.GetCat('CAT_ContractTypes', 5).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 6">{{this.$GVO.GetCat('CAT_ContractTypes', 6).name}}</p>
									<p class="text-right" v-if="objData.contracttypeid == 7">{{this.$GVO.GetCat('CAT_ContractTypes', 7).name}}</p>
								</div>
								<div class="object-row objDots">
									<p >Оплата</p><span></span>
									<div  class="objectPass-row text-right">                                        
										<p v-if="objData.b_mortgage == 1">Ипотека</p>
										<p v-if="objData.b_militarymortgage == 1">Военная ипотека</p>
										<p v-if="objData.b_subsidy == 1">Субсидии</p>
										<p v-if="objData.b_maternitycapital == 1">Материнский капитал</p>
										<p v-if="objData.b_installment == 1">Рассрочка</p>	
									</div>				
								</div>

							</div>
						</collapse-item>
					</collapse>    
				</div>
			</div>

			<div class="priceFlow mb-5" v-if="typeof objData.Anal[0] != 'undefined'">
				<div class="col-sm-12 col-md-6 priceChart px-0" v-if="objData.Olap.length > 0">
					<card class="card-chart">
						<template v-slot:header>
							<h4>Динамика цены{{strSetChartData}}</h4>
							<h4 class="card-title" :class="[{'text-success':bLastPrice},{'text-danger':!bLastPrice}]"><i class="tim-ic mr-2" :class="[{'ic-arrow-top':bLastPrice},{'ic-arrow-bottom':!bLastPrice},{'text-success':bLastPrice},{'text-danger':!bLastPrice}]"></i>на {{idynAmRub}}</h4>
						</template>
						<div class="chart-area">
							<line-chart
							:labels="OlapChart.chartData.labels"
							:chart-data="OlapChart.chartData"
							:extra-options="OlapChart.extraOptions"
							:height="200"
							>
							</line-chart>
						</div>
					</card>
				</div>

				<div class="col-sm-12 col-md-5 flatPass px-4" v-if="(objData.Anal.length == 1) && (objData.Anal[0].dm_procent != 0 || objData.Anal[0].dm_procent >= -75 || objData.Anal[0].dm_procent != null)">
					<div class="flatPass-container">
						<div class="bigPrice" v-if="objData.Anal[0].dm_procent >= -75"><h3>{{YearPrognoz}}%</h3><p>Средний рост цены в год</p></div>
						<div class="flatPass-row objDots" v-if="typeof objData.Anal[0] != 'undefined'"><p>Старт продаж, цена</p><span></span><p>{{$GVO.formatAmount(parseFloat(objData.Anal[0].start_amount))}}</p></div>
						<div class="flatPass-row objDots"><p>Старт продаж, цена за м2</p><span></span><p>{{$GVO.formatAmount(parseFloat(objData.MinMaxAnal[0].start_amount_m))}}</p></div>
						<div class="flatPass-row objDots"><p>Динамика цены, руб.</p><span></span><p>{{idynAmRub}}</p></div>
						<div class="flatPass-row objDots"><p>Динамика цены, %</p><span></span><p>{{idynAmPr}}%</p></div>
						<div class="flatPass-row objDots"><p>Динамика цены за м2</p><span></span><p>{{idynAmMetr}}</p></div>
					</div>                    
				</div>
			</div>

			<!--div class="objectProgress mb-5">
				<h4>Отделка</h4>
				
				<el-carousel :autoplay="false" arrow="always"  type="card" height="250px">
					<el-carousel-item v-for="item in 4" :key="item">
						<div class=""></div>
					</el-carousel-item>
				</el-carousel>
			</div--><!--временно, пока нет инфы от кураторов-->

			<div class="mortgage">
				<div class="mortgage-title">
					<h4>Калькулятор ипотеки</h4>
					<h4 v-if="strMortageProg !=''">Программа: <span>{{strMortageProg}}</span></h4>
				</div>
				<div class="mortgage-content">
					<div class="col-md-5 col-lg-4 banks">
						<p>Выберите банковскую программу для этой квартиры</p>
						<div class="banks-scroll">

							<card v-for="(bank) in objData.Banks" :key="bank.id"  class="bank-card mt-3" :class="{ active: bank.bankprogramid === activeItem}"> <!--  :class="[{'IsBankTab':bIsBankTab}]"--> <!--:class="bank.id ? 'bankselected' : ''"-->
								<div @click="SetMortageCalc(bank)">
									<div class="bank-header">
										<div class="bank-header">
											<div class="bank-photo mr-3 mb-2">
												<img :src="`/DATA/${bank.logo_to_site}`" alt="" class="bank-photo-img">
											</div>
											<div class="bank-col">
												<h4 class="text-primary mb-0">{{bank.bankname}}</h4>
												<p>&laquo;{{bank.programname}}&raquo;</p>
											</div>                                    
										</div>                                
									</div>
									<div class="bank-text">
										<div class="row mx-0">
											<p class="mr-2">Ставка от {{bank.ratepercent}}%</p>
											<p>Мес. платёж: {{$GVO.formatAmount(monthPay(bank))}}</p>
										</div>										
										<!--p>Сумма кредита от {{$GVO.formatAmount(parseFloat(bank.creditsummin))}} до {{$GVO.formatAmount(parseFloat(bank.creditsummax))}}</p-->
										<p v-html="strFstPay(bank)"></p>
									</div>
								</div>
							</card>
						</div>
					</div>
					<div class="col calcs">
						<div class="mortgage-calc mb-4">
							<div class="calc-row mb-3">
								<div class="col-md col-sm-6 mb-3">
									<p class="card-title">Стоимость квартиры, {{$GVO.formatAmount(parseFloat(objData.app_flatcostwithdiscounts))}}</p>
								</div>
								<div class="col-md col-sm-6">
									<p class="card-title">Ставка, %</p>
									<base-input
										placeholder="Ставка"
										type="number"
										v-model="objMCalc.prcStavka"
									></base-input>
								</div>
							</div>
							<div class="calc-row">
								<div class="col-md col-sm-6 mb-3">
									<p class="card-title">Первоначальный взнос, {{parseInt(objMCalc.fstPay)}}%</p>
									<slider v-model="objMCalc.fstPay" :start="60" :range="{'min':[0], 'max':[90]}" :options="{step:5}" type="info"></slider>
								</div>                           
								<div class="col-md col-sm-6">
									<p class="card-title">Срок кредита, {{parseInt(objMCalc.creditTime)}} лет</p>
									<slider v-model="objMCalc.creditTime" :start="15" :range="{'min':[1], 'max':[30]}" :options="{step:1}" type="info"></slider>
								</div>                          
							</div>
							<base-button type="success" @click="FindCreditProg()" simple>Подобрать</base-button>
						</div>

						<p>Результат подбора</p>
						<div class="payment mt-3">
							<div class="monthly-pay"> 
								<h4>Ежемесячный платеж</h4>
								<h4>{{this.$GVO.formatAmount(parseFloat(strMonthPay))}}</h4>
							</div>
							<div class="monthly-pay">
								<p>Сумма кредита</p>
								<p>{{this.$GVO.formatAmount(parseFloat(strCreditSumm))}}</p>
							</div>
							<div class="monthly-pay">
								<p>Первоначальный взнос</p>
								<p>{{this.$GVO.formatAmount(parseFloat(strMCalcFstPay))}}</p>
							</div>
						</div>

					</div>

				</div>
			</div>
		  
		</card>        
		<!--pre>{{objData}}</pre-->
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Carousel, CarouselItem, } from "element-ui";	
import LineChart from 'src/components/Charts/LineChart';
import config from '@/config';
import {  Slider } from 'src/components/index';
import ReCuratorContacts from 'src/our_components/ReCuratorContacts.vue'; 
import moment from 'moment';
import VueMoment from 'vue-moment';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import mapSettings from 'src/conf/yandexmap.js';

export default {
	name: 'ReSearchFlatBig',
	components: {
		Collapse,
		CollapseItem,
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		LineChart,
		Slider,
		ReCuratorContacts,
		yandexMap, ymapMarker,
	},
	props: {
		objData: Object,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		flatPass: {
			type: String,
			default: 'Паспорт квартиры',
		},
		objectPass: {
			type: String,
			default: 'Общая информация',
		},
	},
	data () {
		return {
			ver: 1,
			Banks_orig: [],
			isOpenContacts: true,
			objMCalc:{
				fstPay: 60,		// %
				creditTime: 15,	// лет
				prcStavka: 11,	// %
				selected: false,
			},
			strMortageProg: '',
			OlapChart: {
				chartData: {
					labels: [],
					datasets: [
						{
							label: 'Цена',
							fill: true,
							borderColor: config.colors.info,
							borderWidth: 2,
							borderDash: [],
							borderDashOffset: 0.0,
							pointBackgroundColor: config.colors.info,
							pointBorderColor: 'rgba(255,255,255,0)',
							pointHoverBackgroundColor: '#2380f7',
							pointBorderWidth: 20,
							pointHoverRadius: 4,
							pointHoverBorderWidth: 15,
							pointRadius: 4,
							data: []
						}
					]
				},
				extraOptions:{
					points: {show: true},
					lines: {show: true},
					xaxis: { mode: "time", timeformat: "%d.%m.%y" } // похоже не работает, хотя за основу взят chart.js  //маша: сейчас в документации не Mode, а type: "time" -- в применении разницы не заметила
				},
			},
			yamap_settings: { ...mapSettings },
			yamap_coords: [59.93984485554249, 30.314527237792984],
			yamap_zoom: 17,
			yamap_controls:['zoomControl','typeSelector'],
			yamap_markers:{
				coords: [59.93984485554249, 30.314527237792984],
				id: '1',
			},
			masImgs:'',
			bankSelected: false,
			activeItem: null,
		}
	},
	watch: {
		objData: function(val){
			this.yamap_coords = [this.objData.gk_lat,this.objData.gk_lot];
			this.yamap_markers.coords = [this.objData.gk_lat,this.objData.gk_lot];
		}
	},
	computed: {
		bLastPrice: function(){
			//function PrintFlatPriceChange
			if(parseFloat(this.objData.app_flatcostwithdiscounts) > parseFloat(this.objData.app_last_amount)) return true;
			else return false;
		},
		bDynZnak: function(){
			let iRet = this.objData.app_flatcostwithdiscounts-this.objData.Anal[0].start_amount;
			if(iRet > 0) return true;
			else return false;
		},
		strSetChartData: function(){
			this.OlapChart.chartData.labels = [];
			this.OlapChart.chartData.datasets[0].data = [];
			for (let i = 0; i < this.objData.Olap.length; i++) {
				let strDate = moment(this.objData.Olap[i].dt_from).format("DD.MM.YY");
				if(strDate == "Invalid date") strDate = '';
				this.OlapChart.chartData.labels.push(strDate);
				this.OlapChart.chartData.datasets[0].data.push(this.objData.Olap[i].min_amount);
			}
			return '';
		},
		YearPrognoz: function(){
			let znak = '';
			let iRet = this.objData.app_flatcostwithdiscounts-this.objData.Anal[0].start_amount;
			if(this.bDynZnak) znak = '+ ';
			return `${znak}${this.objData.Anal[0].dm_procent}`;
		},
		idynAmRub: function(){
			let znak = '';
			if(typeof this.objData.Anal[0] != 'undefined'){
				let iRet = this.objData.app_flatcostwithdiscounts-this.objData.Anal[0].start_amount;
				if(this.bDynZnak) znak = '+ ';
				return `${znak}${this.$GVO.formatAmount(parseFloat(iRet))}`;
			}
			return '';
		},
		idynAmPr: function(){
			let znak = '';
			let iRet = this.objData.app_flatcostwithdiscounts-this.objData.Anal[0].start_amount;
			if(this.bDynZnak) znak = '+ ';
			return `${znak}${((this.objData.app_flatcostwithdiscounts*100/this.objData.Anal[0].start_amount)-100).toFixed(1)}`;
		},
		idynAmMetr: function(){
			let znak = '';
			let iRet = this.objData.app_metrecostwithdiscounts - this.objData.MinMaxAnal[0].start_amount_m;
			if(iRet > 0) znak = '+ ';
			return `${znak}${this.$GVO.formatAmount(parseFloat(iRet))}`;
		},
		strMCalcFstPay: function(){
			const iAmount = parseInt(this.objData.app_flatcostwithdiscounts);
			return (iAmount*this.objMCalc.fstPay)/100;
		},
		strCreditSumm(){
			const iAmount = parseInt(this.objData.app_flatcostwithdiscounts);
			return iAmount - this.strMCalcFstPay;
		},
		strMonthPay(){
			const iAmount = parseInt(this.objData.app_flatcostwithdiscounts);
			let iTmpAmount = iAmount - (iAmount * this.objMCalc.fstPay)/100;
			if(this.objMCalc.fstPay == 0){
				iTmpAmount = iAmount;
			}
			let iPerMonth = Math.round( (iTmpAmount * (parseFloat(this.objMCalc.prcStavka)/1200)) / (1 - Math.pow( (1+parseFloat(this.objMCalc.prcStavka)/1200) , (1-12*parseInt(this.objMCalc.creditTime)) )) );
			return iPerMonth;
		},
		masFlatImages: function(){
			let masImgs = [];
			if(this.objData.app_image != '')
				masImgs.push({filename:`/DATA/flat_files/${this.objData.gk_name_tr}/${this.objData.app_image}`});
			if(this.objData.app_floor_image != '')
				masImgs.push({filename:`/DATA/flat_files/${this.objData.gk_name_tr}/${this.objData.app_floor_image}`});
			if(this.objData.gk_avatar != '')
				masImgs.push({filename:`/DATA/complex_files/NewComplexFiles/${this.objData.gk_avatar}`});

			return masImgs;
		},
		app_swatercloset: function(){
			let strRet = '';
			let masWC = this.objData.app_swatercloset.split('+');
			if(masWC.length == 1){
				if (masWC[0].indexOf('с') !== -1) return 'Совместный';
			}else{
				for (let i = 0; i < masWC.length; i++) {
					let element = masWC[i];
					if(element.indexOf('т') !== -1) strRet += 'Туалет+';
					if(element.indexOf('в') !== -1) strRet += 'Ванна+';
					if(element.indexOf('сн') !== -1) strRet += 'Сауна+';
					if(element.indexOf('с') !== -1) strRet += 'Совместный+';
				}
				strRet = strRet.slice(0,strRet.length-1);
				if (strRet == 'Туалет+Ванна' || strRet == 'Ванна+Туалет') strRet = 'Раздельный';
			}
			return strRet;
		},
		sold: function(){
			if (parseInt(this.objData.sold) == 1){
				if(parseInt(this.objData.app_stat) == 3){
					return 'Забронировано';
				}else{
					return 'В продаже';
				}
			}else{
				return 'Продано';
			}
		}
	},
	methods: {
		GoToPres(){
			const objGetParams = this.$GVO.GetAllGet();
			location.href=`/data/module/sso?show_pres=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
		},
		backToGK(){
			const objGetParams = this.$GVO.GetAllGet();			
			location.href=`/data/module/sso/object/complex/${this.objData.gk_name_tr}?=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
			//object/complex/${objData.gk_name_tr}
		},
		backByHistory(){
			this.$router.back();
		},
		toSearchObj(){
			const objGetParams = this.$GVO.GetAllGet();
			location.href=`/data/module/sso?=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
			//object/complex/${objData.gk_name_tr}
		},
		toSearchObjRegular(){
			//const objGetParams = this.$GVO.GetAllGet();
			location.href=`/data/module/sso`;
			//object/complex/${objData.gk_name_tr}
		},
		AddToPres(){
			const objGetParams = this.$GVO.GetAllGet();
			if(!this.$GVO.isEmpty(objGetParams)){
				this.$GVO.ApiCall('INSUPD_OBJ_TO_PRES',{
					obj:'presentations',
					flt:{
						client_id:objGetParams.client_id,
						task_id:objGetParams.task_id,
						taskend_id:objGetParams.taskend_id
					},iData:{
						app_id:this.objData.app_id,
						type: 1
					}
				})
				.then((objApi) => {
					if(objApi.success === true){
						this.objData.inPresentation = 1;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			}else{
				alert('Нет параметров задачи и клиента');
			}
		},
		openContacts(){            
			this.isOpenContacts = !this.isOpenContacts;
		},
		SetMortageCalc(objBank){
			//console.log(objBank);			
			//this.bIsBankTab = !this.bIsBankTab;
			this.objMCalc.fstPay = parseFloat(objBank.firstpaypercentmin);
			//this.objMCalc.creditTime = parseInt(Math.round(objBank.periodmax/2));
			this.objMCalc.creditTime = parseInt(objBank.periodmax);
			this.objMCalc.prcStavka = parseFloat(objBank.ratepercent);
			this.strMortageProg = `банк ${objBank.bankname}, «${objBank.programname}»`;
			/*if(objBank.bankprogramid) {
				//this.bankSelected = true;
			}*/
			this.activeItem = objBank.bankprogramid;
			//this.objBank[index] = i;
			//this.activeItem = i;
		},	
		strFstPay(objBank){
			const iAmount = parseInt(this.objData.app_flatcostwithdiscounts);
			let iTmpAmount = iAmount - (iAmount * objBank.firstpaypercentmin)/100;
			let strFstPay = `Сумма: от ${this.$GVO.formatAmount(parseFloat(objBank.creditsummin))} до ${this.$GVO.formatAmount(parseFloat(objBank.creditsummax))},<br>Первоначальный взнос от ${this.$GVO.formatAmount(parseFloat((iAmount*objBank.firstpaypercentmin)/100))} (${objBank.firstpaypercentmin}%)`;
			if(objBank.firstpaypercentmin == 0){
				strFstPay = 'Без первоначального взноса';
				iTmpAmount = iAmount;
			}
			return strFstPay;
		},
		monthPay(objBank){
			const iAmount = parseInt(this.objData.app_flatcostwithdiscounts);
			let iTmpAmount = iAmount - (iAmount * objBank.firstpaypercentmin)/100;
			if(objBank.firstpaypercentmin == 0){
				iTmpAmount = iAmount;
			}
			let iPerMonth = Math.round( (iTmpAmount * (parseFloat(objBank.ratepercent)/1200)) / (1 - Math.pow( (1+parseFloat(objBank.ratepercent)/1200) , (1-12*parseInt(objBank.periodmax)) )) );
			return iPerMonth;
		},
		FindCreditProg(){
			this.strMortageProg = '';
			if (this.Banks_orig.length == 0) {
				this.Banks_orig = JSON.parse(JSON.stringify(this.objData.Banks));
			}
			if(this.Banks_orig.length != this.objData.Banks.length){
				this.objData.Banks = JSON.parse(JSON.stringify(this.Banks_orig));
			}
			//console.log(this.objData.Banks);
			const masfiltredBankProgs = this.objData.Banks.filter((e) => {
				//return (e.firstpaypercent <= this.objMCalc.fstPay) && (e.periodmin <= this.objMCalc.creditTime && e.periodmax >= this.objMCalc.creditTime) && (e.ratepercent <= this.objMCalc.prcStavka);
				return (e.firstpaypercentmin <= parseFloat(this.objMCalc.fstPay)) && (e.periodmin <= parseFloat(this.objMCalc.creditTime) && e.periodmax >= parseFloat(this.objMCalc.creditTime)) && (e.ratepercent <= parseFloat(this.objMCalc.prcStavka));
			});
			//console.log(masfiltredBankProgs);
			this.objData.Banks = masfiltredBankProgs;
		},
		setChartData(){
			this.OlapChart.chartData.labels = [];
			this.OlapChart.chartData.datasets[0].data = [];
			for (let i = 0; i < this.objData.Olap.length; i++) {
				let strDate = moment(this.objData.Olap[i].dt_from).format("DD.MM.YY");
				if(strDate == "Invalid date") strDate = '00.00.00';
				this.OlapChart.chartData.labels.push(strDate);
				this.OlapChart.chartData.datasets[0].data.push(this.objData.Olap[i].min_amount);
			}
		},
		
	},
	mounted(){
		//this.setChartData();
		if(typeof this.objData != 'undefined'){
			this.yamap_coords = [this.objData.gk_lat,this.objData.gk_lot];
			this.yamap_markers.coords = [this.objData.gk_lat,this.objData.gk_lot];
		}
	}
}
</script>
<style scoped>

.flatHeader {display: flex; padding: 15px; justify-content: space-between; flex-wrap: wrap;}
.flatHeader-btn {display: flex; flex-wrap: wrap;}
.flatTitles {display: flex; flex-direction: column;}
.flatTitles h4 {margin-bottom: 5px;}
.flatPhotos {height: auto; flex-shrink: 0;}
.flatPass {flex-shrink: 2;}
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.flatInfo {display: flex; justify-content: space-between; flex-wrap: wrap; padding: 20px 5px 15px 15px; border-radius: 6px; border: 1px solid #01b0e0;}


/*===carousel===============================*/

.ReSearchFlatBig >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.ReSearchFlatBig >>>  button:focus {outline: none!important;}
.ReSearchFlatBig >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.ReSearchFlatBig >>> .el-carousel__arrow--right {right: 0;}
.ReSearchFlatBig >>> .el-carousel__arrow--left {left: 0;}
.flatPhotos img {height: 100%; border: 1px solid transparent; margin: 0 auto; display: block; object-fit: contain;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 

/*===collapse===============================*/

.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.flatPass-container {display: flex; flex-direction: column;}
.flatPass-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.flatPass-btn {display: flex; justify-content: space-between; margin-top: 10px;}
.flatPass-btn > button {width: 100%;}
.flatPass-btn > button:first-child {margin-right: 15px;}
.flatPass-row h3, .bigPrice h3 {margin-bottom: 0px;}
.contats-booking {display: flex; flex-wrap: wrap;}

/*===map===============================*/
.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap; border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.objectProgress, .mortgage, .bank-card, .mortgage-calc, .payment {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px;}
.ReSearchFlatBig .map {height: auto;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap; justify-content: space-between; border-bottom: 1px solid #01b0e0; padding-bottom: 7px;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {/*min-width: 100px;*/ margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 


.priceChart {display: flex; flex-direction: column;}
.bigPrice {width: 100%; padding: 15px; border-radius: 6px; background: linear-gradient(90deg, #1d83bd 0%, #00BF9A 100%); text-align: center; margin-bottom: 15px;}
.bigPrice h3, .bigPrice p {color: #fff;}


/*===chart===============================*/
.priceChart >>> .card-chart {border: 1px solid #01b0e0; border-radius: 6px;}
.priceChart >>> .card-chart h4 {margin-bottom: 0px;}
.priceChart >>> .card-chart .chart-area {height: auto;}

/*===mortgage===============================*/
.mortgage-title, .bank-header {display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 10px;}
.bank-header {display: flex; flex-wrap: nowrap;}
.bank-col {display: flex; flex-direction: column; justify-self: flex-end;}
.bank-col p {margin-bottom: 0px;}
.bank-text {display: flex; flex-direction: column;}
.mortgage-content {display: flex; flex-wrap: wrap;}
.banks {padding-left: 0px; padding-right: 5px;}
.banks-scroll {height: 500px; overflow-y: scroll; padding-right: 10px;}
.calcs {padding-right: 0px;}
.calcs >>> .input-group-append {cursor: pointer;}
.bank-photo-img {display: block; max-width: 100px; height: auto;}
.bank-card >>> .card-body {padding: 0px;}
.white-content .card:not(.card-white) .bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}
.bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; border:1px solid #BA54F5;}
.bankselected {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.bank-card.active {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.IsBankTab {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; outline: none; border:1px solid #BA54F5;}
/*.bank-card:active {border:1px solid #BA54F5; box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}*/
.calc-row {display: flex; flex-wrap: wrap;}
.ReSearchFlatBig >>> .form-control + .input-group-append .input-group-text {background: transparent;}
.monthly-pay {display: flex; justify-content: space-between; flex-wrap: wrap;}
.monthly-pay h4 {color: #00bf9a;}
.gkTaskLink  {color: #9e77f3; font-weight: 300;}
.gkTaskLink:hover {color: #01b0e0; cursor: pointer;}
.ReSearchFlatBig >>> .bank-text br {content: ""; display: block; margin-top: 5px;}
.flat-carousel img {background-color: #fff;}

@media (max-width: 768px) {	
	.flatPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.flatPass-btn {flex-wrap: wrap;}
	.flatPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.mortgage-calc .btn, .flatHeader-btn {margin-top: 15px; width: 100%;}
	.flatHeader {padding: 15px 0px;}
}

</style>
